module.exports = require("./ks-IN");